import {
	CAPABILITY_TYPE_CHAPS,
	CAPABILITY_TYPE_IFT,
	CAPABILITY_TYPE_BACS,
	CAPABILITY_TYPE_FASTER_PAYMENTS,
	TYPE_BACS,
	TYPE_CHAPS,
	TYPE_FPS,
	TYPE_IFT,
	TYPE_IBFT,
	TYPE_IOOP,
	TYPE_IBBP,
	TYPE_CBFT,
	TYPE_COOP,
	TYPE_CIAT,
	TYPE_CBBP,
	TYPE_BCR,
	TYPE_BDB,
	TYPE_BFT,
	TYPE_BBP,
	TYPE_IAT,
	TYPE_OOP,
	TYPE_LFDP,
	TYPE_FDP,
	TYPE_SO,
	TYPE_RFDP,
	TYPE_RPI,
} from '../../config';

export const mapPaymentTypeToCapability = (paymentType) => {
	switch (paymentType) {
		case TYPE_IFT:
		case TYPE_IBFT:
		case TYPE_IOOP:
		case TYPE_IBBP:
			return CAPABILITY_TYPE_IFT;
		case TYPE_CHAPS:
		case TYPE_CBFT:
		case TYPE_COOP:
		case TYPE_CIAT:
		case TYPE_CBBP:
			return CAPABILITY_TYPE_CHAPS;
		case TYPE_FPS:
		case TYPE_BFT:
		case TYPE_BBP:
		case TYPE_IAT:
		case TYPE_OOP:
		case TYPE_LFDP:
		case TYPE_FDP:
		case TYPE_SO:
		case TYPE_RFDP:
		case TYPE_RPI:
			return CAPABILITY_TYPE_FASTER_PAYMENTS;
		case TYPE_BACS:
		case TYPE_BDB:
		case TYPE_BCR:
			return CAPABILITY_TYPE_BACS;
		default:
			return undefined;
	}
};
